import { useSelector } from "react-redux";
import { RootState } from "../../redux/store/store";
import { LoadingState } from "../../redux/reducers/loadingReducer";

const useIsLoading = (): LoadingState => {
  const isLoading = useSelector((state: RootState) => state.loading);
  return isLoading;
};

export default useIsLoading;
